import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '../core';
import { GroupsComponentsModule } from './groups-components.module';
import { LicensesModule } from '../licenses/licenses.module';
import { StudentsModule } from '../students/students.module';
import { GroupsRoutingModule } from './groups-routing.module';
import { GroupLogService } from './services/group-log.service';
import { GroupsComponent } from './groups/groups.component';
import { GroupComponent } from './group/group.component';
import { GroupDashboardService } from './services/group-dashboard.service';
import { GroupLogComponent } from './group-log/group-log.component';
import { EmailsModule } from '../emails/emails.module';
import { GroupsTutorizationModule } from 'app/groups-tutorization/groups-tutorization.module';
import { GroupDataComponent } from './group/group-data/group-data.component';
import { GroupEnrollmentComponent } from './group/group-enrollment/group-enrollment.component';
import { GroupNotificationsComponent } from './group/group-notifications/group-notifications.component';
import { GroupLicensesComponent } from './group/group-licenses/group-licenses.component';
import { GroupActivityComponent } from './group/group-activity/group-activity.component';
import { GroupStudentsScoreComponent } from './group/group-students-score/group-students-score.component';
import { WidgetModule } from 'app/widget/widget.module';
import { GroupStudentsImportComponent } from './group/group-students-import/group-students-import.component';
import { GroupDashboardComponent } from './group/group-dashboard/group-dashboard.component';
import { GroupDashboardWidgetsService } from './services/group-dashboard-widgets.service';
import { StudentsStatusWidgetComponent } from './group/widgets/students-status-widget/students-status-widget.component';
import { RecentActivityWidgetComponent } from './group/widgets/recent-activity-widget/recent-activity-widget.component';
import { ActiveStudentsWidgetComponent } from './group/widgets/active-students-widget/active-students-widget.component';
import { AmountWidgetComponent } from './group/widgets/amount-widget/amount-widget.component';
import { AutoevaluationWidgetComponent } from './group/widgets/autoevaluation-widget/autoevaluation-widget.component';
import { SurveysWidgetComponent } from './group/widgets/surveys-widget/surveys-widget.component';
import { StudentsProgressWidgetComponent } from './group/widgets/students-progress-widget/students-progress-widget.component';
import { AverageProgressWidgetComponent } from './group/widgets/average-progress-widget/average-progress-widget.component';
import { RatioFinishedWidgetComponent } from './group/widgets/ratio-finished-widget/ratio-finished-widget.component';
import { ProgressSectionsWidgetComponent } from './group/widgets/progress-sections-widget/progress-sections-widget.component';
import { NpsWidgetComponent } from './group/widgets/nps-widget/nps-widget.component';
import { StudentsWidgetComponent } from './group/widgets/students-widget/students-widget.component';
import { MostActiveStudentsWidgetComponent } from './group/widgets/most-active-students-widget/most-active-students-widget.component';
import { LastFinishedStudentsWidgetComponent } from './group/widgets/last-finished-students-widget/last-finished-students-widget.component';
import { RatioWidgetComponent } from './group/widgets/ratio-widget/ratio-widget.component';
import { GroupStudentsScoreService } from './services/group-students-score/group-students-score.service';
// Mars1 group components
import { Mars1GroupComponent } from './mars1-group/mars1-group.component';
import { Mars1GroupConfigComponent } from './mars1-group/mars1-group-config/mars1-group-config.component';
import { Mars1GroupDataComponent } from './mars1-group/mars1-group-data/mars1-group-data.component';
import { Mars1GroupTutorizationComponent } from './mars1-group/mars1-group-tutorization/mars1-group-tutorization.component';
// end Mars components

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    GroupsComponentsModule,
    WidgetModule,
    GroupsRoutingModule,
    LicensesModule,
    StudentsModule,
    EmailsModule,
    GroupsTutorizationModule
  ],
  declarations: [
    GroupsComponent,
    GroupComponent,
    GroupLogComponent,
    GroupNotificationsComponent,
    GroupDataComponent,
    GroupEnrollmentComponent,
    GroupLicensesComponent,
    GroupActivityComponent,
    GroupStudentsScoreComponent,
    GroupDashboardComponent,
    StudentsStatusWidgetComponent,
    RecentActivityWidgetComponent,
    ActiveStudentsWidgetComponent,
    AmountWidgetComponent,
    AutoevaluationWidgetComponent,
    SurveysWidgetComponent,
    GroupStudentsImportComponent,
    StudentsProgressWidgetComponent,
    AverageProgressWidgetComponent,
    RatioFinishedWidgetComponent,
    ProgressSectionsWidgetComponent,
    NpsWidgetComponent,
    StudentsWidgetComponent,
    MostActiveStudentsWidgetComponent,
    LastFinishedStudentsWidgetComponent,
    RatioWidgetComponent,
    // mars1 group components
    Mars1GroupComponent,
    Mars1GroupConfigComponent,
    Mars1GroupDataComponent,
    Mars1GroupTutorizationComponent
  ],
  exports: [
    GroupComponent,
    GroupLogComponent,
    StudentsStatusWidgetComponent,
    RecentActivityWidgetComponent,
    ActiveStudentsWidgetComponent,
    AmountWidgetComponent,
    AutoevaluationWidgetComponent,
    SurveysWidgetComponent,
    StudentsProgressWidgetComponent,
    AverageProgressWidgetComponent,
    RatioFinishedWidgetComponent,
    ProgressSectionsWidgetComponent,
    NpsWidgetComponent,
    StudentsWidgetComponent,
    MostActiveStudentsWidgetComponent,
    LastFinishedStudentsWidgetComponent,
    RatioWidgetComponent,
    // mars1 group components
    Mars1GroupComponent
  ],
  providers: [GroupLogService, GroupDashboardWidgetsService, GroupDashboardService, GroupStudentsScoreService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class GroupsModule {}
